import React, { useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify'
import { AppContext } from '../context/AppContext'
import { updatePlanSetting, getPlan } from '../services/adminServices'

export const AdminSettings = () => {
  const { login } = useContext(AppContext);
  const [pricing, setPricing] = useState({
    remote: { price: 0, discount: 0 },
    advertisment: { price: 0, discount: 0 },
    tracking: { price: 0, discount: 0 },
    calling: { price: 0, discount: 0 },
  });

  const handleChange = (type, field, value) => {
    setPricing((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [field]: field === 'isActive' ? value : Number(value),
      },
    }));
  };

  const getPricingPlan = async (e) => {
    let result = await getPlan(login.token)
    if (result.success) {
      setPricing({ ...pricing, ...result.data })
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = await updatePlanSetting(login.token, pricing)
    if (result.success) {
      getPricingPlan()
      toast.success("Settings saved successfully!");
    } else {
      toast.error("Failed to save settings. Please try again.");
    }
  };

  const renderSection = (label, type) => (
    <div className="border p-4 rounded mb-4 col-lg-12">
      <h3 className="font-semibold mb-2">{label}</h3>
      <div className="mb-2">
        <label className="block font-medium">Per User Price (INR)</label>
        <input
          type="number"
          value={pricing[type].price}
          min={0}
          onChange={(e) => handleChange(type, 'price', e.target.value)}
          className="w-full p-2 border rounded mt-1"
          placeholder="Enter amount in INR"
          required
        />
      </div>
      <div>
        <label className="block font-medium">Discount (%)</label>
        <input
          type="number"
          value={pricing[type].discount}
          onChange={(e) => handleChange(type, 'discount', e.target.value)}
          min="0"
          max="100"
          className="w-full p-2 border rounded mt-1"
          placeholder="Enter discount percentage"
          required
        />
      </div>
      <div>
        <label className="block font-medium">Is Active</label>
        <input
          type="checkbox"
          checked={pricing[type].isActive}
          onChange={(e) => handleChange(type, 'isActive', e.target.checked)}
          className="w-full p-2 border rounded mt-1"
        />
      </div>
    </div>
  );


  useEffect(() => {
    getPricingPlan()
  }, [])


  return (
    <div className="details-table mt-3">
      <div className="search-container mb-3">
        <h4><i class="fas fa-cog"></i> Settings </h4>
      </div>
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded p-4">
        <div className='d-flex justify-content-between align-items-center'>
          <div className='col-lg-6 m-1'>
            {renderSection('Remote Plan', 'remote')}
            {renderSection('Advertisement Plan', 'advertisment')}
          </div>
          <div className='col-lg-6 m-1'>
            {renderSection('Tracking Plan', 'tracking')}
            {renderSection('Calling Plan', 'calling')}
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary px-4 py-2"
          style={{ backgroundColor: '#1edd60', border: "none" }}
        >
          Save Settings
        </button>
      </form>
    </div>
  );
};
